import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { SlabAnalysisRequest, SlabAnalysisResponse } from './types';

export function useSlabAnalysisQuery(req: SlabAnalysisRequest) {
  const [debounced, setDebounced] = useState(req);
  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(req), 300);
    return () => window.clearTimeout(t);
  }, [req]);
  return useQuery<SlabAnalysisResponse>({
    queryKey: ['analysis', 'slabs', debounced],
    queryFn: async () => (await api.post('/api/analysis/slabs', debounced)).data,
    placeholderData: (prev) => prev,
    retry: false,
    staleTime: 60_000,
  });
}
